import { atom } from "jotai";

/**
 * The LaunchDarkly context key whose `identify()` has resolved, meaning the
 * current flag values now reflect that context. `null` until the first identify
 * resolves and while a newer identify is in flight.
 *
 * `FeatureFlagsProvider` calls `identify(context)` asynchronously after the
 * customer renders, so a consumer that must act on a customer-scoped flag
 * exactly once should wait until this equals the expected context key before
 * reading the flag — otherwise it can read the previous (anonymous) value.
 */
export const ldIdentifiedContextKeyAtom = atom<string | null>(null);
